module.exports = __webpack_public_path__ + "img/book-cover.19927d9d.jpg";